import { TemplateFormValues, StagesFormValues } from '../../types';

export const initialStagesConstructorFormValue: TemplateFormValues = {
  isActive: false,
  description: '',
  templateName: '',
  businessProcess: '',
};

export const stagesConstructorFormRow: StagesFormValues = {
  id: null,
  name: '',
  checklist: [],
};
